module.exports = {
    500: {
        'internal-server-error': {
            title:    'Fehler',
            subTitle: 'Unerwartet',
            message:  'Leider ist ein unerwarteter Fehler aufgetreten.',
        },
    },

    trips: {
        duplicate: {
            missingEntityID: 'Duplizieren von Fahrten ohne ID nicht möglich.',
            missingNewEntityID: 'Beim Duplizieren der Fahrt ist ein Fehler aufgetreten.',
        },
        export: {
            missingAtLeastOneTimestamp: 'Der Dienstplan-Export ohne Zeitangabe ist nicht möglich.',
        },
    },

    drivers: {
        delete_drivers: {
            SEQUELIZE_FOREIGN_KEY_NOT_EXISTS_ERROR: {
                'driverID': 'Dieser Fahrer kann nicht gelöscht werden, weil er noch mindestens einer Fahrt zugewiesen wurde.',
                'bosch_trip_driverVessels_driverID': 'Dieser Fahrer kann nicht gelöscht werden, weil er noch mindestens einer Fahrt zugewiesen wurde.',
            },
        },
    },
}